import GoodsList from '@/views/mobile/GoodsList/index'
import GoodsDetails from '@/views/mobile/GoodsList/goodsDetails'
import ExchangeList from '@/views/mobile/GoodsList/exchangeList'

// 定义路由路径数列表
export default [{
  path: '/goodsList',
  name: '商品',
  component: GoodsList
},
{
  path: '/goodsDetails',
  name: '商品详情',
  component: GoodsDetails
},
{
  path: '/exchange',
  name: '兑换记录',
  component: ExchangeList
}]



// WEBPACK FOOTER //
// ./src/views/mobile/GoodsList/routers/index.js